module.exports = __webpack_public_path__ + "img/powerball_ad2.46de6201.png";